import { BehaviorSubject, Subject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';


let DefaultState = {
    isVisible: false,
    topic: ""
}

class EmailAlertsLayerState extends BehaviorSubject {
    constructor() {
        super(Object.assign({}, DefaultState));
        this._state = null;

    }
    get state() {
        if (this._state == null) {
            this._state = Object.assign({}, DefaultState)
        }
        return this._state;
    }
    get isVisible() {
        return this.state.isVisible;
    }
    set isVisible(flag = this.state.iVisible) {
        if (flag != this.isVisible) {
            this.state.isVisible = flag;
            this.next(this.state);
        }
    }
    get topic(){
    	return this.state.topic;
    }
    set topic(val=""){
    	if(val!=this.topic){
    		this.state.topic = val;
    		this.next(this.state);
    	}
    }
}
class EmailAlertsLayerApi {
    constructor() {
        this._state = null;
    }

    get state() {
        if(this._state == null) {
            this._state = new EmailAlertsLayerState;
        }
        return this._state;
    }
    show(){
    	this.state.isVisible = true;
    }
    hide(){
    	this.state.isVisible = false;
    }
    setTopic(topic=""){
    	this.state.topic = topic;
    }
}

class EmailAlertsLayer {
    constructor(el = null) {
        this._el = el;
        this._api = null;
        this._onCloseClick = null;
        this._closeIconEl = null;
        this._closeButtonEl = null;
        this._topicEl = null;
    }
    init(){
    	if(this.el!=null){
	    	this.api.state.pipe(distinctUntilChanged(null,state=>{
	    		return state.topic;
	    	})).subscribe(state=>{
	    		this.handleTopicChange(state.topic);
	    	})
	    	this.api.state.pipe(distinctUntilChanged(null,state=>{
	    		return state.isVisible
	    	})).subscribe(state=>{
	    		this.handleVisibleChange(state.isVisible);
	    	})
	    	this.closeIconEl.onclick = null;
	    	this.closeButtonEl.onclick = null;
            this.closeIconEl.addEventListener('click',this.handleCloseClick.bind(this));
            this.closeButtonEl.addEventListener('click',this.handleCloseClick.bind(this));
	    	this.onCloseClick.subscribe(e=>{
	    		this.api.hide();
	    	})
	    	document.querySelector('.page-body').appendChild(this.el);
    	}
    	
    }
    get onCloseClick(){
    	if(this._onCloseClick==null){
    		this._onCloseClick = new Subject();
    	}
    	return this._onCloseClick;
    }
    get api(){
    	if(this._api == null){
    		this._api = new EmailAlertsLayerApi();
    	}
    	return this._api;
    }
    get el() {
        if (this._el == null) {
            this._el = document.getElementById("palertadexcontainer");
        }
        return this._el;
    }
    set el(el = null) {
        this._el = el;
    }
    get topicEl(){
    	if(this._topicEl == null){
    		this._topicEl = this.el.querySelector('.patopic');
    	}
    	return this._topicEl;
    }
    get closeIconEl(){
    	if(this._closeIconEl==null){
    		this._closeIconEl = this.el.querySelector('.closebtn2 > a');
    	}
    	return this._closeIconEl;
    }
    get closeButtonEl(){
    	if(this._closeButtonEl==null){
    		this._closeButtonEl =this.el.querySelector('.subbtn > input[type="button"]');
    	}
    	return this._closeButtonEl;
    }
    handleCloseClick(e){
        e.preventDefault();
        this.onCloseClick.next(e);
    }
    handleTopicChange(topic){
    	this.topicEl.innerHTML = topic;
    }
    handleVisibleChange(isVisible=this.api.state.isVisible){
    	if(isVisible){
    		window.showModal("palertadexcontainer");
    		this.el.classList.remove("inactive");
    		this.el.classList.add("active");
    		this.el.style.display = "block";
    	}
    	else{
    		this.el.style.display = "none";
    		this.el.classList.remove("active");
    		this.el.classList.add("inactive");
    		window.hideModal("palertadexcontainer");
    	}
    }

}

export { EmailAlertsLayer }
export { EmailAlertsLayerApi }
export { EmailAlertsLayerState }